if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
            'use strict';
            if (target == null) { // TypeError if undefined or null
                throw new TypeError('Cannot convert undefined or null to object');
            }

            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
                var nextSource = arguments[index];

                if (nextSource != null) { // Skip over if undefined or null
                    for (var nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true
    });
}



function CiCookie(canOutputConsole) {
    this.canOutputConsole = canOutputConsole ? canOutputConsole : true;
}

CiCookie.prototype.output = function (value) {
    if (this.canOutputConsole)
        console.log(decodeURIComponent(value))
}

CiCookie.prototype.set = function (name, value, optionsArg) {

    options = {
        path: '/',
        domain: location.host.match('(([a-z\-]+)(?:\.com|\.test|\.fr|\.co.uk))') ? location.host.match('(([a-z\-]+)(?:\.com|\.test|\.fr|\.co.uk))')[0] : location.host,
    };

    if (location.protocol == 'https:') {
        optionsHTTPS = {
            SameSite: 'none',
            Secure: true
        };

        options = Object.assign(options, optionsHTTPS);
    }

    options = Object.assign(options, optionsArg);

    if (options.expires)
        options.expires = new Date(new Date().getTime() + options.expires * 24 * 60 * 60 * 1000).toUTCString();

    var updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

    for (var optionKey in options) {
        updatedCookie += "; " + optionKey;
        var optionValue = options[optionKey];

        if (optionValue !== !0)
            updatedCookie += "=" + optionValue
    }

    document.cookie = updatedCookie;

    if (value)
        this.output("set cookie: " + name + ' -> ' + value);
    else
        this.output("devare cookie: " + name);

    return name
}

CiCookie.prototype.get = function (name) {
    var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    var cookieValue = matches ? decodeURIComponent(matches[1]) : '';
    // this.output("get value cookie: " + name + ' -> ' + cookieValue);

    return cookieValue;
}

CiCookie.prototype.devare = function (name) {
    this.set(name, "", {
        'max-age': -1
    })
}

var Cookie = new CiCookie();
var referrer = document.referrer;
var strGET = location.search.replace('?', '');
if (strGET === '' && location.hash.indexOf('?') >= 0) {
    //Check for malformed SPA URLs. e.g. activtrak.com/#app?utm_campaign=test
    strGET = location.hash.slice(location.hash.indexOf('?') + 1);
}
var findMainHost = location.host.match('(([a-z\-]+)(?:\.com|\.fr|\.co.uk))');
var host = findMainHost ? findMainHost[0] : location.host;
var arrGET = strGET.split('&');
var referrerSplit = referrer.split("/");
var referrer2;
var objCookieName = {
    'utm_medium': '',
    'utm_source': '',
    'utm_campaign': '',
    'utm_content': '',
    'utm_term': '',
    'utm_landing': '',
    'utm_referrer': '',
    'gclid': '',
};



function UTMDefinition() {
    if ( arrGET[0] && ( ~strGET.indexOf('utm') ) ) {

        arrGET.forEach(function (item) {
            var name = item.split('=')[0];
            var value = item.split('=')[1];
            if ( objCookieName.hasOwnProperty( name ) ) objCookieName[name] = value;
        });

    } else {
        if (referrer) {
            if ( ~referrerSplit[2].indexOf( host ) ) {
                objCookieName.utm_medium = 'DIRECT';
                objCookieName.utm_source = 'DIRECT';

            } else if (~referrerSplit[2].indexOf('duckduckgo')
            || ~referrerSplit[2].indexOf('yandex')
            || ~referrerSplit[2].indexOf('google')
            || ~referrerSplit[2].indexOf('baidu')
            || ~referrerSplit[2].indexOf('lycos')
            || ~referrerSplit[2].indexOf('altavista')
            || ~referrerSplit[2].indexOf('yahoo')
            || ~referrerSplit[2].indexOf('teoma')
            || ~referrerSplit[2].indexOf('hotbot')
            || ~referrerSplit[2].indexOf('bing')
            || ~referrerSplit[2].indexOf('ask')
            || ~referrerSplit[2].indexOf('aol')
            || ~referrerSplit[2].indexOf('dmoz') ) {
                objCookieName.utm_medium = 'Organic_Search';
                objCookieName.utm_source = referrer.match(/https?:\/\/(?:[-\w]+\.)?([-\w]+)\.\w+(?:\.\w+)?\/?.*/i)[1];
                objCookieName.utm_referrer = referrerSplit[2];

            } else if (~referrerSplit[2].indexOf('facebook')
            || ~referrerSplit[2].indexOf('youtube')
            || ~referrerSplit[2].indexOf('slideshare')
            || ~referrerSplit[2].indexOf('linkedin')
            || ~referrerSplit[2].indexOf('twitter')) {
                objCookieName.utm_medium = 'Social';
                objCookieName.utm_source = referrer.match(/https?:\/\/(?:[-\w]+\.)?([-\w]+)\.\w+(?:\.\w+)?\/?.*/i)[1];
                objCookieName.utm_referrer = referrerSplit[2];

            } else {
                objCookieName.utm_medium = 'Referral';
                objCookieName.utm_source = 'Referral';
                objCookieName.utm_referrer = referrerSplit[2];
            }

        } else {
            objCookieName.utm_medium = 'DIRECT';
            objCookieName.utm_source = 'DIRECT';
        }
    }

    var currentURL = window.location.href;
    var trimmedURL = currentURL.split('?')[0];
    objCookieName.utm_landing = trimmedURL || currentURL;

    for (var name in objCookieName) {

        if ( !objCookieName[name] ) {
            if (name === 'gclid') {
                objCookieName[name] = '';
            } else {
                objCookieName[name] = 'not_provided';
            }
        }

        if (name !== 'gclid') {
            objCookieName[name] = objCookieName[name].toLowerCase();
        }

        Cookie.set(name, objCookieName[name], {
            domain: host
        });

    }
    var firstVisitParams = ['utm_medium', 'utm_source', 'utm_campaign', 'utm_term', 'utm_content', 'utm_landing', 'utm_referrer'];
    firstVisitParams.forEach(function (name) {
       var firstVisitCookieName = 'first_visit_' + name;
       var firstVisitExistingVal = Cookie.get(firstVisitCookieName);
       if (!firstVisitExistingVal) {
           Cookie.set(firstVisitCookieName, objCookieName[name], {
               expires: 60,
               domain: host
           });
       }
       //Force existing cookies that aren't lower case to lower case
       if (firstVisitExistingVal.toLowerCase() !== firstVisitExistingVal) {
           Cookie.set(firstVisitCookieName, firstVisitExistingVal.toLowerCase(), {
               expires: 60,
               domain: host
           });
       }
    });
}



function UTMscripInit() { 

    if (!Cookie.get('utm_medium') || strGET.indexOf('utm') >= 0) {
        UTMDefinition();
    } else {
        if ( !referrer ) referrerSplit[2] = 'not_provided';

        if (~referrerSplit[2].indexOf('duckduckgo')
        || ~referrerSplit[2].indexOf('yandex')
        || ~referrerSplit[2].indexOf('google')
        || ~referrerSplit[2].indexOf('baidu')
        || ~referrerSplit[2].indexOf('lycos')
        || ~referrerSplit[2].indexOf('altavista')
        || ~referrerSplit[2].indexOf('yahoo')
        || ~referrerSplit[2].indexOf('teoma')
        || ~referrerSplit[2].indexOf('hotbot')
        || ~referrerSplit[2].indexOf('bing')
        || ~referrerSplit[2].indexOf('ask')
        || ~referrerSplit[2].indexOf('aol')
        || ~referrerSplit[2].indexOf('dmoz')
        || ~referrerSplit[2].indexOf('facebook')
        || ~referrerSplit[2].indexOf('youtube')
        || ~referrerSplit[2].indexOf('slideshare')
        || ~referrerSplit[2].indexOf('linkedin')
        || ~referrerSplit[2].indexOf('twitter') ) {
            referrer2 = referrerSplit[2];
        }

        if ( Cookie.get('utm_source') != referrerSplit[2]
        && ~referrerSplit[2].indexOf( host ) ) {
            objCookieName.utm_medium = Cookie.get('utm_medium');
            objCookieName.utm_source = Cookie.get('utm_source');
            objCookieName.utm_campaign = Cookie.get('utm_campaign');
            objCookieName.utm_content = Cookie.get('utm_content');
            objCookieName.utm_landing = Cookie.get('utm_landing');
            objCookieName.utm_referrer = Cookie.get('utm_referrer');
            objCookieName.utm_term = Cookie.get('utm_term');
            objCookieName.gclid = Cookie.get('gclid');

        } else {
            for (var name in objCookieName) Cookie.devare(name);
            UTMDefinition();
        }
    }
    setUuid();
    // console.dir(objCookieName);
}

//https://stackoverflow.com/a/8809472
function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();//Timestamp
    var d2 = (performance && performance.now && (performance.now()*1000)) || 0;//Time in microseconds since page-load or 0 if unsupported
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16;//random number between 0 and 16
        if(d > 0){//Use timestamp until depleted
            r = (d + r)%16 | 0;
            d = Math.floor(d/16);
        } else {//Use microseconds since page-load if supported
            r = (d2 + r)%16 | 0;
            d2 = Math.floor(d2/16);
        }
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

function setUuid() {
    if (!Cookie.get('uuid')) {
    Cookie.set('uuid', generateUUID(), {expires: 365});
    }
}